import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

type ClientPortalProps = {
  children: React.ReactNode
  selector?: string
}

/**
 * A reusable component that creates a React portal to render its children into a specified DOM element.
 * This is useful for rendering components without causing a SSR hydration mismatch.
 */
export default function ClientPortal({ children, selector = '#portal-root' }: ClientPortalProps) {
  const [target, setTarget] = useState<Element | null>(null)

  useEffect(() => {
    setTarget(document.querySelector(selector))
  }, [selector])

  if (!target) return null

  return createPortal(children, target)
}
